import { useEffect, useRef, useState } from "react";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
// import ReactQuill, { Quill } from "react-quill";
import { useDispatch, useSelector } from "react-redux";
import { homePageActions } from "../../../../_store/home.slice";
import FroalaEditor from "react-froala-wysiwyg";
import Button from "../../../../components/common/ui/Button";
import SelectInput from "./../../../../components/common/ui/Inputs/SelectInput";

// CSS (make sure your bundler loads these)
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js"; // All plugins
import Swal from "sweetalert2";
import { config } from "../../Editor_Config/Froalaconfig";

function CommitteeDesc({ errorMessage }) {
  const dispatch = useDispatch();

  const { data } = useSelector((x) => x?.home?.homePageContentResponse);
  const isFirstRender = useRef(true);
  const { textEditorTemplate } = useSelector((x) => x?.home);
  const { ColTwoAlginments, ColThreeAlginments, editorColumn } = useSelector(
    (x) => x?.dropDown
  );
  // const [editorStates, setEditorStates] = useState({
  //   sectionOneDescription: "",
  // });

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  // section dropdown
  const [secOneFilter, setSecOneFilter] = useState({
    Column: null,
    ContentAlignment: "",
  });

  const handleEditorFilter = (e, name, page) => {
    const value = e?.value;

    const columnMap = {
      1: { Column: 1, ContentAlignment: "" },
      2: { Column: 2, ContentAlignment: "left-4" },
      3: { Column: 3, ContentAlignment: "left" },
    };

    const setters = {
      1: setSecOneFilter,
      // 2: setSecTwoFilter,
      // 3: setSecThreeFilter,
    };

    const setter = setters[page];
    if (!setter) return; // safeguard

    setter((prev) => {
      if (name === "Column") {
        return {
          ...prev,
          ...(columnMap[value] || { Column: null, ContentAlignment: "" }),
        };
      }
      return { ...prev, ContentAlignment: value };
    });
  };

  const handleSearchSection = (e, status, name, column, alignment) => {
    e.preventDefault();
    const payload = { ...homePageData };
    const template = textEditorTemplate?.data;

    if (column === 1) {
      // Filter template for columnSplit = 1
      const htmlValue = template?.filter((d) => d.columnSplit === 1);
      if (htmlValue && htmlValue.length > 0) {
        payload[name] = htmlValue[0].html;
      }
    } else {
      // Filter template for columnSplit = 2
      const htmlValue = template?.filter(
        (d) => d.columnSplit === column && d.fileAlignment === alignment
      );
      if (htmlValue && htmlValue.length > 0) {
        payload[name] = htmlValue[0].html;
      }
    }

    // Dispatch update action
    dispatch(homePageActions.updateHomePageResponse(payload));
  };

  // const config = {
  //   // key: `${process.env.REACT_APP_API_Froala_Key}`, // Key for Froala
  //   placeholderText: "Start typing...",
  //   charCounterCount: true,
  //   toolbarButtons: [
  //     "bold",
  //     "italic",
  //     "underline",
  //     "strikeThrough",
  //     "subscript",
  //     "superscript",
  //     "|",
  //     "fontFamily",
  //     "fontSize",
  //     "color",
  //     "inlineStyle",
  //     "paragraphStyle",
  //     "|",
  //     "paragraphFormat",
  //     "align",
  //     "formatOL",
  //     "formatUL",
  //     "outdent",
  //     "indent",
  //     "quote",
  //     "|",
  //     "insertLink",
  //     "insertImage",
  //     "insertVideo",
  //     "insertFile",
  //     "insertTable",
  //     "|",
  //     "emoticons",
  //     "specialCharacters",
  //     "embedly",
  //     "insertHR",
  //     "selectAll",
  //     "clearFormatting",
  //     "|",
  //     "print",
  //     "spellChecker",
  //     "help",
  //     "html",
  //     "|",
  //     "undo",
  //     "redo",
  //   ],
  //   toolbarButtonsXS: null,
  //   toolbarButtonsSM: null,
  //   toolbarButtonsMD: null,
  //   imageUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,
  //   // `

  //   // Video upload endpoint (if needed)
  //   videoUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // File upload endpoint
  //   fileUploadURL: `${process.env.REACT_APP_API_URL}/media/upload`,

  //   // Extra settings
  //   imageUploadParam: "file", // 👈 match multer field name
  //   fileUploadParam: "file",
  //   videoUploadParam: "file",
  //   events: {
  //     "image.uploaded": function (response) {
  //       const res = JSON.parse(response);
  //       debugger;
  //       if (res.link) {
  //         this.image.insert(
  //           `${process.env.REACT_APP_API_IMAGE_URL}${res.link}`, // ✅ use IMAGE_URL, not API_URL
  //           true,
  //           null,
  //           this.image.get(),
  //           response
  //         );
  //         return false; // prevent Froala default insert
  //       }
  //     },
  //   },

  //   // Example: image upload endpoint on your server

  //   // Additional options you might use:
  //   // imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  //   // fileUploadURL: '/api/uploads/froala-file',
  //   //
  // };

  // const Size = Quill.import("attributors/style/size");
  // var Font = Quill.import("formats/font");

  const homePageData = { ...data };

  // Font.whitelist = [
  //   "arial",
  //   "courier-new",
  //   "georgia",
  //   "tahoma",
  //   "times-new-roman",
  //   "verdana",
  //   "impact",
  //   "wingdings",
  // ];

  // Size.whitelist = [
  //   "8pt",
  //   "10pt",
  //   "12pt",
  //   "14pt",
  //   "18pt",
  //   "24pt",
  //   "36pt",
  //   "48px",
  // ];

  // Quill.register(Size, true);

  //   const CustomStyles = `
  // .ql-picker.ql-font .ql-picker-label::before,
  // .ql-picker.ql-font .ql-picker-item::before {
  //     font-family: initial !important;  /* Reset to default font */
  //     content: attr(data-value) !important;  /* Show font name */
  //     text-transform: capitalize !important;  /* Capitalize first letter */
  //     font-size: 16px !important;  /* Increase font size */
  // }

  //   .ql-picker.ql-font { width: 160px !important; }

  //     .ql-picker.ql-size .ql-picker-label::before,
  //     .ql-picker.ql-size .ql-picker-item::before {
  //         content: attr(data-value) !important;
  //         text-transform: none !important;
  //     }
  //         .ql-font-arial { font-family: Arial, sans-serif; }
  //         .ql-font-courier-new { font-family: Courier-New, monospace; }
  //         .ql-font-georgia { font-family: Georgia, serif; }
  //         .ql-font-tahoma { font-family: Tahoma, sans-serif; }
  //         .ql-font-times-new-roman { font-family: Times-New-Roman, serif; }
  //         .ql-font-verdana { font-family: Verdana, sans-serif; }
  //         .ql-font-impact { font-family: Impact, sans-serif; }
  //         .ql-font-wingdings { font-family: Wingdings; }

  //          /* Hide only the preview inside the tooltip */
  //         .ql-tooltip .ql-preview {
  //             max-width: 7px !important;
  //             height: 0px !important;
  //             overflow: hidden !important;
  //             white-space: nowrap !important;
  //             display: inline-block !important;
  //             visibility: hidden; /* Hides text but keeps the element */
  //         }
  //         .ql-snow .ql-tooltip::before {
  //             content: none !important; /* Removes the "Visit URL:" text */
  //         }
  //       .ql-snow .ql-tooltip a.ql-action::after {
  //           border-right: 1px solid #ccc;
  //           content: 'Edit';
  //           margin-left: 7px;
  //           padding-right: 8px;
  //       }
  // `;

  //   const modules = {
  //     toolbar: [
  //       [{ font: Font.whitelist }],
  //       [{ size: Size.whitelist }],
  //       ["bold", "italic", "underline", "strike", "blockquote"],
  //       [{ list: "ordered" }, { list: "bullet" }],
  //       [{ script: "sub" }, { script: "super" }],
  //       [{ indent: "-1" }, { indent: "+1" }],
  //       [{ direction: "rtl" }],
  //       [{ color: [] }, { background: [] }],
  //       [{ align: [] }],
  //       ["link"],
  //       ["clean"],
  //     ],
  //     clipboard: {
  //       matchVisual: false,
  //     },
  //   };

  useEffect(() => {
    Swal.close();
  }, []);

  // const handleEditorChanges = (content, name) => {
  //   let cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");

  //   // Only dispatch if content actually changed
  //   if (homePageData[name] !== cleanedContent) {
  //     dispatch(
  //       homePageActions?.updateHomePageResponse({
  //         ...homePageData,
  //         [name]: cleanedContent,
  //       })
  //     );
  //   }
  // };
  // useEffect(() => {
  //   const descValue = { ...editorStates };
  //   descValue.sectionOneDescription = homePageData?.sectionOneDescription;
  //   setEditorStates(descValue);
  // }, [homePageData?.sectionOneDescription]);

  // const handleEditorChanges = (content, name) => {
  //   const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
  //   setEditorStates((prev) => ({
  //     ...prev,
  //     [name]: cleanedContent,
  //   }));

  //   // Do not dispatch if unchanged
  //   if (data[name] === cleanedContent || !data) return;

  //   dispatch(
  //     homePageActions?.updateHomePageResponse({
  //       ...data,
  //       [name]: cleanedContent,
  //     })
  //   );
  // };

  const handleFroalaEditorChanges = (content, name) => {
    debugger;
    if (isFirstRender.current) return;
    const cleanedContent = content.replace(/^(<p>(&nbsp;|\s)*<\/p>)+/, "");
    // setEditorStates((prev) => ({
    //   ...prev,
    //   [name]: cleanedContent,
    // }));

    // Do not dispatch if unchanged
    if (homePageData?.[name] === cleanedContent || !homePageData) return;

    const payload = { ...homePageData };
    payload[name] = cleanedContent;

    // return;
    dispatch(homePageActions?.updateHomePageResponse(payload));
    // homePageData[name] = cleanedContent;
    // dispatch(homePageActions?.updateHomePageResponse(homePageData));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e?.target;
  //   homePageData[name] = value;
  //   dispatch(homePageActions?.updateHomePageResponse(homePageData));
  // };

  return (
    <>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100 ">
        <div className="d-flex flex-wrap align-items-center border p-3 gap-3">
          <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
            {/* Committee Description */}
            Section - 1
          </h1>
          <div className="col-4">
            <SelectInput
              options={editorColumn}
              label="Column"
              name="Column"
              handleChange={(e) => handleEditorFilter(e, "Column", 1)}
              value={secOneFilter?.Column}
            />
          </div>

          <div className="col-4">
            <SelectInput
              options={
                secOneFilter?.Column === 2
                  ? ColTwoAlginments
                  : ColThreeAlginments
              }
              label="Content Alignment"
              name="ContentAlignment"
              handleChange={(e) => handleEditorFilter(e, "ContentAlignment", 1)}
              value={secOneFilter?.ContentAlignment}
              isDisabled={
                secOneFilter?.Column === 1 || secOneFilter?.Column === undefined
              }
            />
          </div>
          <div className="col-2">
            <Button
              type="submit"
              label="Search"
              status="primary"
              className="mt-4"
              onClick={(e) => {
                handleSearchSection(
                  e,
                  1,
                  "sectionOneDescription",
                  secOneFilter?.Column,
                  secOneFilter?.ContentAlignment
                );
              }}
            />
          </div>
        </div>
        <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-12">
              <FroalaEditor
                tag="textarea"
                name="sectionOneDescription"
                config={config} // your toolbar, plugins, etc.
                model={homePageData?.sectionOneDescription || ""} // ✅ value binding
                onModelChange={(e) => {
                  // ✅ onChange equivalent
                  handleFroalaEditorChanges(e, "sectionOneDescription");
                }}
                className={`editor-block ${
                  errorMessage?.["sectionOneDescription"] ? "input-error" : ""
                }`}
              />

              {errorMessage?.sectionOneDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.sectionOneDescription}
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="p-3 row">
          <div className="row mb-4">
            <div className="col-md-4">
              <TextInput
                name="sectionOneTitle"
                label="Title"
                placeholder="Title"
                value={homePageData?.sectionOneTitle}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                required
              />
            </div>

            <div className="col-md-8">
              <label
                className={`form-label col-form-label  w-100 fs-5 form-label-custom-visible `}
              >
                Description {<span className="text-danger">*</span>}
              </label>

              <div className="quill-container" id="toolbar">
                <style>{CustomStyles}</style>
                <div>
                  <ReactQuill
                    name="sectionOneDescription"
                    theme="snow"
                    value={editorStates.sectionOneDescription || ""}
                    onChange={(e) => {
                      handleEditorChanges(e, "sectionOneDescription");
                    }}
                    modules={modules}
                    className={`editor-block ${
                      errorMessage["sectionOneDescription"] ? "input-error" : ""
                    }`}
                  />
                </div>
              </div>
              {errorMessage?.sectionOneDescription && (
                <div className="text-danger fw-700 fs-6 mt-1">
                  {errorMessage?.sectionOneDescription}
                </div>
              )}
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}

export default CommitteeDesc;
